import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { TableBody } from './common/TableBody/TableBody'
import { TableCell } from './common/TableCell/TableCell'
import { TableHead } from './common/TableHead/TableHead'
import { TableRow } from './common/TableRow/TableRow'

import styles from './Table.module.scss'

export const Table = ({ children, className = undefined }) => (
  <Box className={styles.container}>
    <table className={cx(styles.table, { [className]: Boolean(className) })}>
      {children}
    </table>
  </Box>
)

Table.Body = TableBody
Table.Cell = TableCell
Table.Head = TableHead
Table.Row = TableRow
